import type { SquawkDetailPublic } from "@common/client"
import {
  StatusGlyph,
  type StatusKind,
} from "@/routes/_layout/quotes/-components/status-glyphs"
import { type Stage, stageLabel, stageOf } from "../-lib/status"

const KIND: Record<Stage, StatusKind> = {
  needs_review: "pending",
  accepted: "done",
  rejected: "rejected",
  accepted_verified: "verified",
  rejected_verified: "failed",
}

export function StageIcon({ stage }: { stage: Stage }): React.ReactElement {
  return <StatusGlyph kind={KIND[stage]} label={stageLabel(stage)} />
}

export function StatusIcon({
  squawk,
}: {
  squawk: SquawkDetailPublic
}): React.ReactElement {
  return <StageIcon stage={stageOf(squawk)} />
}
